import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Loadable from 'components/Loadable';
import ProtectedRoute from 'components/ProtectedRoute';
import DashboardLayout from 'layout/Dashboard';
import Loader from 'components/Loader';
import { useAuth } from 'contexts/AuthContext';

const AdminMetrics = Loadable(lazy(() => import('pages_admin/AdminMetrics')));
const CalendarMarkersAdmin = Loadable(lazy(() => import('pages_admin/CalendarMarkers')));

const AdminLayoutGuard = () => {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user || (user.role || '').toString().trim().toLowerCase() !== 'admin') {
    return <Navigate to="/" replace />;
  }
  return (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  );
};

const AdminRoutes = {
  path: '/admin',
  element: <AdminLayoutGuard />,
  children: [
    {
      index: true,
      element: <Navigate to="/admin/metrics" replace />
    },
    {
      path: 'metrics',
      element: <AdminMetrics />
    },
    {
      path: 'calendario',
      element: <CalendarMarkersAdmin />
    }
  ]
};

export default AdminRoutes;
